export const dashboardLanguage = 'dashboard_language';
